module.exports = __webpack_public_path__ + "media/newstyle/images/logo-americanas-9e5131598bfc7bf91e80f2b0becc0f63.png";